const circles = document.querySelectorAll('circle.js-animating-circle');

circles.forEach((circle) => {
    const radius = circle.r.baseVal.value;
    const circumference = 2 * Math.PI * radius;

    circle.style.strokeDasharray = `${circumference} ${circumference}`;
    circle.style.strokeDashoffset = `${circumference}`;

    circle.setProgress = (percent) => {
        const offset = circumference - percent * 0.01 * circumference;
        circle.style.strokeDashoffset = offset;
    };

    circle.setProgress(0);
});

global.quietmark.inView('circle.js-animating-circle').on('enter', (circle) => {
    circle.classList.remove('is-frozen');
    circle.setProgress(circle.dataset.percent);
});
